import { createContext } from 'react';
import type { AfterShipAdsContextValue } from './AfterShipAds.types';

export const AfterShipAdsContext = createContext<AfterShipAdsContextValue | undefined>(undefined);
